import ArchivedPost from '../archivedPost/ArchivedPost'
import { useState, useEffect, useContext } from 'react'
import Axios from 'axios'
import {AuthContext} from '../../context/AuthContext'
import SkeletonPosts from '../skeletonPosts/SkeletonPosts.jsx'

import './archive.css'
import EmptyStateArchive from '../emptyStateArchive/EmptyStateArchive.jsx'

const ArchivedPosts = () => {
    const [posts, setPosts] = useState([])
    const [isFetching, setIsFetching] = useState(false)
    const {user} = useContext(AuthContext)

    const API = process.env.REACT_APP_API_URL

    //Delete Post
    const deletePost = (_id) => {
        setPosts((posts) => posts.filter(post => post._id !== _id))
    }

    //Fetching the posts everytime there's an update
    useEffect(() => {
        const fetchPosts = async () => {
            setIsFetching(true)
            const res = await Axios.get(API + `posts/archive/${user._id}`)
            setPosts(res.data.archive)
            setIsFetching(false)
        }
        fetchPosts();
    }, [API, user._id])
    return (
        <div className="feed">
            <div className="feedWrapper">
            {isFetching ? <SkeletonPosts /> : (posts.length !== 0 ? posts.map((post) => <ArchivedPost key = {post._id} post = {post} onPostHide={deletePost}/>) : <EmptyStateArchive />)}
            </div> 
        </div>
    )
}

export default ArchivedPosts
